import { useState } from 'react'
import { CSVLink } from 'react-csv'
import { mapIds } from '../../../utils/APIs/users'
import { setPageTitle } from '../../../utils/utilities'

const CUSTOMER_NUMBER = 'CUSTOMER_NUMBER'
const USER_ID = 'USER_ID'

const IDMapper = () => {
  setPageTitle('Admin | User Dump')
  const [type, setType] = useState(CUSTOMER_NUMBER)
  const [listOfIds, setListOfIDs] = useState('')
  const [userData, setUserData] = useState([])

  const handleSubmit = async () => {
    if (listOfIds !== '') {
      const response = await mapIds({
        token: localStorage.getItem('authToken'),
        type,
        listOfIds
      })
      if (response?.status === 200) {
        setUserData(response.data)
      }
    }
  }
  return (
    <div className="container mx-auto">
      <h1>Mass Look-Up</h1>
      <h3>Search by</h3>
      <select
        value={type}
        onChange={(e) => setType(e.target.value)}
        className="input block w-full"
      >
        <option value={CUSTOMER_NUMBER}>CUSTOMER_NUMBER</option>
        <option value={USER_ID}>USER_ID</option>
      </select>
      <h3>Comma separated list</h3>
      <input
        value={listOfIds}
        onChange={(e) => setListOfIDs(e.target.value)}
        className="input block w-full"
        required
      />
      <button onClick={handleSubmit} className="button-confirm mb-2">
        Submit
      </button>
      {userData.length > 0 && (
        <CSVLink className="button-fill" data={userData}>
          Download
        </CSVLink>
      )}
    </div>
  )
}

export default IDMapper
